import { Mountain, Leaf, Droplets, ArrowUpRight } from "lucide-react";

const ICONS = [Mountain, Leaf, Droplets];
const IMAGES = [
  "https://images.unsplash.com/photo-1762146828422-50a8bd416d3c",
  "https://images.pexels.com/photos/5802827/pexels-photo-5802827.jpeg",
  "https://images.unsplash.com/photo-1770773923578-6457f9303d91",
];

export const Services = ({ t }) => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-40 bg-[#FDFDF9] border-y border-[#183321]/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 md:mb-20">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#183321]/40" />
              <span className="text-xs uppercase tracking-[0.25em] text-[#4A6B53] font-semibold">
                {t.services.eyebrow}
              </span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#183321] font-medium">
              {t.services.title}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-base md:text-lg leading-relaxed text-[#4A6B53]">
              {t.services.sub}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {t.services.items.map((item, idx) => {
            const Icon = ICONS[idx];
            return (
              <article
                key={idx}
                data-testid={`service-card-${idx}`}
                className="group relative bg-[#EAF1E8] border border-[#183321]/10 rounded-sm p-8 md:p-10 hover:-translate-y-1 hover:shadow-[0_24px_40px_-24px_rgba(24,51,33,0.25)] transition-all duration-500"
              >
                <div className="aspect-[4/3] overflow-hidden rounded-sm mb-8 -mx-2 -mt-2">
                  <img
                    src={IMAGES[idx]}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    loading="lazy"
                  />
                </div>

                <div className="flex items-center justify-between mb-5">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-sm bg-[#2A4D35] text-[#FDFDF9] flex items-center justify-center">
                      <Icon size={18} />
                    </div>
                    <span className="text-xs uppercase tracking-widest text-[#4A6B53] font-semibold">
                      {item.tag}
                    </span>
                  </div>
                  <ArrowUpRight
                    size={20}
                    className="text-[#183321]/40 group-hover:text-[#C26D5C] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                  />
                </div>

                <h3 className="font-serif text-2xl md:text-3xl text-[#183321] font-medium mb-4 leading-tight">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base leading-relaxed text-[#4A6B53]">
                  {item.body}
                </p>
              </article>
            );
          })}
        </div>

        <div className="mt-16 md:mt-20 pt-10 border-t border-[#183321]/10">
          <p className="text-sm md:text-base text-[#4A6B53] italic font-serif">
            {t.services.footer}
          </p>
        </div>
      </div>
    </section>
  );
};
